import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointoramaSketchObject } from '../../../../potree/utils/PointoramaSketchObject';
import { resolveFloorGroupIdentifier } from '../../../../utils/roomFolders';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];
type Group = Project['state']['groups'][number];

export function createSyncSketchObjectsConfig({ viewer, annotations, groups }: { viewer: NonNullable<RendererContextType['viewer']>; annotations: Annotation[]; groups: Group[] }): SyncConfig<Annotation, PointoramaSketchObject> {
  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'SKETCH_OBJECT'),
    getSceneItems: () => [...(viewer.scene.sketchObjects || [])],
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry/glyph updates are handled by reactive property
    // subscriptions on the scene object.
    create: (source) => {
      const sketchObject = new PointoramaSketchObject(viewer);
      sketchObject.identifier = source.identifier;
      // The scene object's groupIdentifier is the FLOOR membership marker used
      // by runtime filters/blacklists — resolve through a room folder's parent.
      sketchObject.groupIdentifier = resolveFloorGroupIdentifier(groups, source.groupIdentifier);
      sketchObject.finished = true;
      return sketchObject;
    },
    addToScene: (item) => viewer.scene.addSketchObject(item),
    removeFromScene: (item) => viewer.scene.removeSketchObject(item),
  };
}
